export const BASE_URL = 'templates';
